module.exports = __webpack_public_path__ + "media/images/icons/checkmark-teal-4c69d071874ea4e7e905e5473c73a129.svg";